import React from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router';
import defaultAvatar from 'pluton-core/lib/assets/images/default_avatar.png';


class Image extends React.Component {

    static propTypes = {
        defaultSrc: React.PropTypes.string,
        src: React.PropTypes.string,
        width: React.PropTypes.number,
        height: React.PropTypes.number,
        route: React.PropTypes.string,
        imageType: React.PropTypes.string,
        heightAuto: React.PropTypes.bool,
        className: React.PropTypes.string,
        imgClassName: React.PropTypes.string
    };

    static defaultProps = {
        defaultSrc: null,
        src: null,
        width: 28,
        height: 28,
        route: '',
        heightAuto: false,
        className: 'img-wrap',
        imgClassName: 'img-default'
    };

    imgUploadFail() {
        const imageDom = ReactDOM.findDOMNode(this.refs[`image${this.props.src}`]);
        imageDom.src = defaultAvatar;
        return true;
    }

    getImageView() {
        const {
            src,
            defaultSrc,
            width,
            height,
            heightAuto,
            route,
            className,
            imgClassName,
            onClick
        } = this.props;

        const image = (
            <img
                className={imgClassName}
                ref={`image${src}`}
                src={src ? src : defaultSrc}
                width={width}
                height={heightAuto ? heightAuto : height}
                onError={this.imgUploadFail.bind(this)}
            />
        );

        return (
            <div className={className}
                 onClick={onClick}>
                {
                    (route) ?
                        <Link to={route}>{image}</Link>
                        : image
                }
            </div>
        );
    }

    render() {
        return this.getImageView();
    }
}

export default Image;



// WEBPACK FOOTER //
// ./app/components/controls/image/Image.jsx